<template>
    <div class="container">
        <div class="top  mx-auto ">
            <div class="left">
                <!-- <div class="uls" v-for="item in subMenuList" :key="item.id">
                    <div v-for="item2 in item.children" class="cursor text-light" @click="goNav(item)">
                        {{item2.menuName}}
                    </div>
                </div> -->
                <el-collapse class="w-100" accordion>
                    <el-collapse-item v-for="item in subMenuList" :key="item.label" :title="item.label" :name="item.path">
                        <div v-for="item2 in item.children" class="cursor text-light px-2 my-1" @click="goNav(item2)">
                            {{item2.menuName}}
                        </div>
                    </el-collapse-item>
                </el-collapse>
            </div>

            <div class="right py-1 my-1 flex">
                <div>
                    <div class="text-light ">联系我们</div>
                    <div class="text-light fs-3">400-090-0617</div>
                </div>

                <div class="flex">
                    <img style=" width:85px;height: 85px;" src="@/assets/images/index/gzh.jpg" alt="">
                    <span class=" text-light text-center" style="width:85px; font-size: 14px;">微信公众号</span>
                </div>
            </div>
        </div>
        <div class="bottom mx-auto">
            <div style="height:2px;background:rgba(255,255,255,.3);" class="w-100 mb-1">

            </div>
            <div class="text-light beian flex ">
                <div class="">Copyright © 2022-2024 广东省慧训科技发展有限公司 All Rights Reserved.</div> <a class=" text-right" href="https://beian.miit.gov.cn">粤ICP备2024276650号-1</a>
            </div>
        </div>

    </div>
</template>

<script>
export default {
    name: 'publicFooter',
    data() {
        return {
            subMenuList: [{
                    path: "aboutus",
                    label: "关于我们",
                    children: [{
                        id: 0,
                        path: "aboutus",
                        menuName: "公司简介"
                    }, {
                        id: 1,
                        path: "aboutus",
                        menuName: "企业荣誉"
                    }, {
                        id: 2,
                        path: "aboutus",
                        menuName: "廉洁政策"
                    }, {
                        id: 3,
                        path: "afterSales",
                        menuName: "售后服务"
                    }, {
                        id: 4,
                        path: "contactus",
                        menuName: "联系我们"
                    }]
                },
                {
                    path: "product",
                    label: "产品中心",
                    children: [{
                        id: 0,
                        path: "product",
                        menuName: "产品介绍"
                    }, {
                        id: 1,
                        path: "product",
                        menuName: "品牌保证"
                    }, {
                        id: 2,
                        path: "product",
                        menuName: "品牌标识"
                    }, {
                        id: 3,
                        path: "resolveMethods",
                        menuName: "解决方案"
                    },]
                },
                {
                    path: "newsDetails",
                    label: "新闻中心",
                    children: [{
                        id: 0,
                        path: "newsDetails",
                        menuName: "公司新闻"
                    }, ]
                },
                // {
                //     path: "successSimple",
                //     children: [{
                //         id: 0,
                //         menuName: "成功案例"
                //     }, ]
                // },
                {
                    path: "recruit",
                    label: "人才招聘",
                    children: [{
                        id: 0,
                        path: "recruit",
                        menuName: "加入我们"
                    }, ]
                },

            ]
        }
    },
    methods: {
        goNav(item) {
            this.$router.push("/" + item.path)
            // if (item.path === "aboutus") {
            //     this.$router.push("/aboutus")
            // } else if (item.path === "product") {
            //     this.$router.push("/product")
            // } else if (item.path === "newsDetails") {
            //     this.$router.push("/newsDetails")
            // } else if (item.path === "successSimple") {
            //     this.$router.push("/successSimple")
            // } else if (item.path === "recruit") {
            //     this.$router.push("/recruit")
            // }
        }
    },

}
</script>

<style lang="scss" scoped>
ul,
li {
    list-style: none;
}

.container {
    width: 100%;
    padding: 20px 0;
    background: #143b4d;

    >.top {
        width: 70%;
        // justify-content: space-between;
        // align-items: start;

        .left {
            width: 100%;

            ::v-deep .el-collapse {
                border: 0;

                .el-collapse-item__header.is-active {
                    border-bottom-color: rgba(255, 255, 255, .3);
                    color: #3effe1;
                }

                .el-collapse-item__header {
                    background: transparent;
                    border-bottom-color: rgba(255, 255, 255, .3);
                    color: #fff;
                    // #5b7683
                }

                .el-collapse-item__wrap {
                    border-bottom-color: rgba(255, 255, 255, .3);
                }

                .el-collapse-item__content {
                    padding: 0;
                }

                .el-collapse-item__wrap {
                    background: transparent;
                }
            }

            // .uls {
            //     div {
            //         padding: 10px 0;
            //     }
            // }
        }

        .right {
            padding: 0;
            // flex-direction: column;
            justify-content: space-between;

            >div:nth-child(1) {
                display: flex;
                flex-direction: column;
                justify-content: space-around;
            }

            // align-items: flex-end;
            >div:nth-child(2) {
                flex-direction: column;
                justify-content: center;
                align-items: center;
            }

        }
    }

    >.bottom {
        width: 70%;

        >div:nth-child(2) {
            width: 100%;
            justify-content: space-between;
            align-items: center;
        }

        // flex-justify-between flex-align-center w-100
    }
}

.beian a {
    text-decoration: none;
    color: #fff;

    &:hover {
        color: #ff0000;
    }
}

@media all and (max-width:500px) {
    .container {
        width: 100%;
        padding: 20px 10px;
        background: #143b4d;

        >.top {
            width: 100%;

            .left {
                width: 100%;
            }

            .right {
                flex-direction: column;

                >div:nth-child(2) {
                    flex-direction: column;
                    justify-content: center;
                    align-items: flex-start;
                }
            }
        }

        >.bottom {
            width: 100%;

            >div:nth-child(2) {
                width: 100%;
                flex-direction: column;
                align-items: flex-start;

                >* {
                    margin: 5px 0;
                }
            }
        }
    }
}
</style>
